module.exports = __webpack_public_path__ + "img/meditation-icon.4e98a65f.svg";